/**
 * Auth Bridge — tiny decoupled callback registry.
 *
 * Breaks the circular dependency between apiClient and AuthContext:
 *   apiClient imports authBridge (to call logout on 401)
 *   AuthContext imports authBridge (to register the logout callback)
 *   No cycle.
 */

type LogoutCb = () => void;
let _cb: LogoutCb | null = null;

/** AuthProvider calls this on mount to register its logout function */
export function registerGlobalLogout(cb: LogoutCb | null) {
  _cb = cb;
}

/** apiClient calls this when it receives a 401 */
export function triggerGlobalLogout() {
  _cb?.();
}
